import * as React from 'react'
import { SVGProps } from 'react'

const SvgLetter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height={611.994}
    viewBox="0 0 611.993 611.994"
    width={611.993}
    {...props}
  >
    <path d="M572.188 53.58H40.138c-11.28 0-20.897 3.963-28.525 11.888C3.977 73.464 0 83.088 0 94.34v423.951c0 10.968 3.899 20.663 11.612 28.518 7.543 7.714 17.252 11.605 28.525 11.605h532.05c11.28 0 20.649-3.892 28.193-11.605 7.713-7.854 11.612-17.55 11.612-28.518V94.34c.008-22.503-17.244-40.76-39.804-40.76zm3.319 464.711c0 2.335-.998 3.325-3.319 3.325H40.138c-2.321 0-3.319-.99-3.319-3.325V150.103L292.895 411.79c3.609 3.68 7.961 5.308 12.936 5.308h.665c5.641 0 9.999-1.628 13.602-5.308l255.41-261.687v368.188zm0-420.625L306.495 373.01 36.819 97.666V94.34c0-2.618.998-3.963 3.319-3.963h532.05c2.321 0 3.319 1.345 3.319 3.963z" />
  </svg>
)

export default SvgLetter
